import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./styles.css";
const Button = ({ title = "Save", icon, onClick }) => {
  return (
    <div
      className="button__container"
      onClick={() => {
        if (onClick) onClick();
      }}
    >
      <div className="button__text">{title}</div>
      {icon && (
        <div className="button__icon">
          <FontAwesomeIcon icon={icon} />
        </div>
      )}
    </div>
  )
};

export default Button;